import { RecordTable, type RecordTableProps } from "../../shared/components/record_review/RecordTable";
import { useAssessmentRecordReview } from "../hooks/useAssessmentRecordReview";
import { AssessmentReferenceContext } from "../context/AssessmentReferenceContext";

/** Product context selects the relationship; shared record components render every actual field. */
export function AssessmentRecordReview(props: RecordTableProps) {
  const view = useAssessmentRecordReview(props.api, props.sectionContext);
  return <div>
    <div className="cr-strip" aria-label="Products under assessment">
      {view.products.map((product) => <button key={product.product_id} type="button"
        className="cr-record-chip" data-on={product.product_id === view.productId}
        onClick={() => product.product_id !== undefined && view.selectProduct(product.product_id)}>
        <span className="cr-record-chip-stack">
          <span className="cr-record-chip-title">{product.label ?? `Product ${product.product_id}`}</span>
          {product.primary && <span className="cr-record-chip-subtitle">Primary</span>}
        </span>
      </button>)}
    </div>
    <AssessmentReferenceContext.Provider value={view.reference}>
      <RecordTable {...props} api={view.api} />
    </AssessmentReferenceContext.Provider>
  </div>;
}
